import React, { Component } from "react";
import { connect } from "react-redux";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { req_page_lrs_correctLog, req_delete_lrs_correctLog } from "../../api";
import { Card, Button, Table, Select, Input, Modal, message } from "antd";
import CorrectLogAddModal from "./correct-log-add-modal";

class CorrectLogList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      confirmLevel,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_lrs_correctLog(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      confirmLevel,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });

      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_lrs_correctLog(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "證號",
        dataIndex: "TroublemakerId",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "姓名",
        dataIndex: "TroublemakerName",
        width: 30,
      },
      {
        title: "違規內容",
        dataIndex: "TroubleDescription",
        width: 40,
      },
      {
        title: "地點",
        width: 30,
        render: (item) => {
          const { RoomName, RoomCode } = item;
          return (
            <span>
              {RoomCode}{RoomName}
            </span>
          );
        },
      },
      {
        title: "通報者",
        dataIndex: "OperatorName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "通報日期",
        width: 25,
        render: (item) => {
          const { OperatorId, DateTag } = item;
          const { userCode } = this.props.user;
          return (
            <span>
              {DateTag}
              {OperatorId === userCode ? (
                <Button
                  type="dashed"
                  size="small"
                  style={{ color: "Block" }}
                  onClick={() => this.handle_show_ui_modal("delete", item)}
                >
                  <i
                    className="fas fa-trash-alt"
                    style={{ marginRight: "4px" }}
                  ></i>{" "}
                  刪除
                </Button>
              ) : (
                ""
              )}
            </span>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_applycase(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_applycase(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_applycase(pagination.current);
        });
      }
    } else {
      this.api_page_applycase(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        // this.api_add_view_log(item)
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true, item });
        break;
      case "delete":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定刪除此筆數據`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      item,
      pagination,
      searchField,
      searchValue,
      isShowModal,
    } = this.state;

    const title = (
      <div style={{ marginBottom: "4px" }}>
        <Select
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="TroublemakerId">學/職號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button
          type="primary"
          icon={<i className="fas fa-search"></i>}
          onClick={() => this.api_page_items(1)}
          style={{ marginRight: "4px" }}
        >
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>
        <Button
          type="primary"
          icon={<i className="fas fa-plus"></i>}
          onClick={() => this.handle_show_ui_modal("view", null)}
        >
          <span style={{ marginLeft: "4px" }}>新增</span>
        </Button>
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={800}
          onOk={() => {
            this.setState({ isShowModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CorrectLogAddModal log={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(CorrectLogList);
